import React, {Component} from 'react';
import {FormattedMessage, injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import {clearAlerts} from '../../../actions/alertsActions';
import get from 'get-value';
import Loader from '../../Loader';
import {
    ASE_INTERNAL_TICKET_FORM,
    FORM_BUTTON_EDIT,
    FORM_BUTTON_REOPEN,
    FORM_BUTTON_TAKE_BACK,
} from '../../../constants/formConstants';
import {Redirect, withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import {formatInternalTicketNumber} from '../../../utils/utils';
import {editRights} from '../../../constants/aseInternalTicketRights';
import {
    initLoadedAseInternalTicket,
    transformUpdateAseInternalTicketForSave
} from '../Utils';
import formMessages from '../../../intl/afterSales/formMessages';
import PageHeader from '../../common/PageHeader';
import ValidFormattedMessage from '../../common/ValidFormattedMessage';
import formTypeMessages from '../../../intl/common/formTypeMessages';
import checkRoles from '../../common/roleChecker/RoleChecker';
import InternalTicketMasterForm from './forms/InternalTicketMasterForm';
import {
    fetchAseInternalTicket,
    resetAseInternalTicket,
    updateAseInternalTicket
} from '../../../actions/ase/actionAseInternalTicket';
import {
    lockAseInternalTicket,
    resetRedirectAfterAseInternalLockTicket
} from '../../../actions/ase/actionAseInternalLockTicket';

class ViewAseInternalTicketPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            redirectToEdit: false,
            ticketSubmitted: false,
            storedTicketData: {},
            redirectToEditImmediately: false,
            checkStatusSkipAfterUpdateRedirect: false
        };
    }

    componentDidMount() {
        if (!this.props.location.redirectedAfterUpdate) {
            this.props.fetchAseInternalTicket(this.props.match.params.ticketUuid);
        }
    }

    componentWillUnmount() {
        this.props.resetAseInternalTicket();
        this.props.resetRedirectAfterAseInternalLockTicket();
    }

    handleSubmit = (values) => {
        const {submitBy} = values;
        const {ticketData} = this.props;

        switch (submitBy) {
            case FORM_BUTTON_REOPEN:
                this.props.lockAseInternalTicket(this.props.match.params.ticketUuid);
                this.setState({redirectToEdit: true, ticketSubmitted: true, storedTicketData: transformUpdateAseInternalTicketForSave(values)});
                break;
            case FORM_BUTTON_TAKE_BACK:
                this.props.lockAseInternalTicket(this.props.match.params.ticketUuid);
                this.setState({checkStatusSkipAfterUpdateRedirect: true, redirectToEdit: true, ticketSubmitted: true, storedTicketData: transformUpdateAseInternalTicketForSave(values)});
                break;
            case FORM_BUTTON_EDIT:
                this.setState({redirectToEditImmediately: true, redirectToTicket: ticketData.ticket.uuid});
                this.props.resetAseInternalTicket();
                break;
        }
    };

    render() {
        const {
            ticketData,
            loggedUser,
        } = this.props;

        let formType = false;
        if (get(ticketData, 'ticket.formType', {default: false})) {
            formType = ticketData.ticket.formType;
        }

        if (!this.props.lockTicket.isTicketLocking && !this.props.lockTicket.redirect && this.state.ticketSubmitted && this.state.redirectToEdit) {
            this.props.updateAseInternalTicket(this.state.storedTicketData);
            return <Redirect to={{
                pathname: `/ase/internalTicket/edit/${ticketData.ticket.uuid}`,
                redirectedAfterUpdate: true,
                checkStatusSkipAfterUpdateRedirect: !!this.state.checkStatusSkipAfterUpdateRedirect,
            }}/>;
        } else if (this.state.redirectToEditImmediately) {
            return <Redirect to={{
                pathname: `/ase/internalTicket/edit/${this.state.redirectToTicket}`,
            }}/>;
        } else if (!this.props.lockTicket.isTicketLocking && !this.props.lockTicket.redirect && this.state.ticketSubmitted) {
            this.props.updateAseInternalTicket(this.state.storedTicketData);
            this.setState({ticketSubmitted: false, storedTicketData: {}});
        }

        const initializationValue = initLoadedAseInternalTicket(ticketData);

        if (
            ticketData.isTicketLoading
            || ticketData.isTicketCreating
            || !formType
        ) {
            return <Loader/>;
        }

        return (
            <div id="ticketPrint" className="container-fluid">
                <PageHeader title={
                    <>
                        <FormattedMessage {...formMessages.TICKET}/>{' '}
                        {formatInternalTicketNumber(ticketData.ticket.pfxNumber, ticketData.ticket.sfxNumber)}{'-'}
                        <ValidFormattedMessage message={formType} intlMessages={formTypeMessages}/>
                    </>
                }/>
                <div>
                    {formType === ASE_INTERNAL_TICKET_FORM &&
                    <InternalTicketMasterForm form={formType}
                                                 initialValues={initializationValue}
                                                 userRights={editRights['AS_SG_EDITOR'][ticketData.ticket.status]}
                                                 enableReinitialize={true}
                                                 handleSubmit={this.handleSubmit}
                                                 reqFields={[]}
                                                 readOnly/>
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    loggedUser: state.profile.userDetail.roles,
    ticketData: state.aseInternalTicket,
    lockTicket: state.aseLockInternalTicketCheck,
});

ViewAseInternalTicketPage.propTypes = {
    clearAlerts: PropTypes.func.isRequired,
    location: PropTypes.object,
    ticketData: PropTypes.object.isRequired,
    fetchAseInternalTicket: PropTypes.func.isRequired,
    resetAseInternalTicket: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    intl: PropTypes.any.isRequired,
};

export default checkRoles(withRouter(connect(mapStateToProps, {
    fetchAseInternalTicket,
    resetAseInternalTicket,
    lockAseInternalTicket,
    updateAseInternalTicket,
    resetRedirectAfterAseInternalLockTicket,
    clearAlerts,
})(injectIntl(ViewAseInternalTicketPage))), ['AS_SG_EDITOR']);

